export default (node => {
  var bannerData = JSON.parse(node.getAttribute('data-banners'));
  var speed = node.querySelector('[data-element="carousel_speed"]');
  return {
    bannerData,
    speed: (speed === null || speed === void 0 ? void 0 : speed.textContent) * 1000 || 5000
  };
});